// @ts-nocheck
const AdminDashboardSkeleton = () => {

    return (
        <div>Es lädt...</div>
    )
}

export default AdminDashboardSkeleton